import _ from 'lodash';
import dayjs from '../../utils/dayjs';

const defaultAuctionTimeValues = () => {
  return {
    disabledHours: () => {
      return _.range(0, 10).concat(_.range(16, 24));
    },
    disabledMinutes: (selectedHour) => {
      if (selectedHour === 15) return _.range(1, 60);
      return _.range(1, 30).concat(_.range(31, 60));
    },
  };
};

const firstDayAuctionTimeValues = (now, firstHour, selectedHour) => {
  return {
    disabledHours: () => {
      return _.range(0, firstHour).concat(_.range(16, 24));
    },
    disabledMinutes: () => {
      if (selectedHour === 15) return _.range(1, 60);
      const startFromZero = selectedHour <= firstHour && now.minute() < 30;
      return _.range(startFromZero ? 0 : 1, 30).concat(_.range(31, 60));
    },
  };
};

const lastDaysAuctionTimeValues = () => {
  return {
    disabledHours: () => {
      return _.range(0, 15).concat(_.range(16, 24));
    },
    disabledMinutes: () => {
      return _.range(1, 60);
    },
  };
};

const isFirstDaySelected = (value, now) => {
  const threeDaysAhead = now.add(now.hour() > 15 ? 4 : 3, 'day');
  return (
    now.hour() < 15 &&
    threeDaysAhead.startOf('day').isSame(value.startOf('day'), 'day')
  );
};

const isWithin72hOfLastDay = (expirationDate, now) => {
  const parsedExpirationDate = getParsedExpirationDate(expirationDate);
  const diff = parsedExpirationDate.diff(now.endOf('day'), 'day');
  return diff < 3 && diff >= 0;
};

const getParsedExpirationDate = (expirationDate) => {
  return dayjs(expirationDate, 'DD.MM.YYYY', true).endOf('day');
};

export const disabledDate = (current, expirationDate) => {
  const now = dayjs();
  const currentHour = now.hour();
  const threeDaysAhead = now
    .clone()
    .add(currentHour >= 15 ? 3 : 2, 'day')
    .endOf('day');
  const parsedExpirationDate = getParsedExpirationDate(expirationDate);

  if (isWithin72hOfLastDay(expirationDate, now.clone())) {
    const isLastDay = now.endOf('day').diff(parsedExpirationDate, 'day') === 0;
    return (
      current &&
      (current <
        parsedExpirationDate
          .clone()
          .add(isLastDay && currentHour >= 14 ? 0 : -1, 'day') ||
        current > parsedExpirationDate)
    );
  }
  return (
    current && (current < threeDaysAhead || current > parsedExpirationDate)
  );
};

export const disabledTime = (expirationDate, val = dayjs()) => {
  const value = val.clone();
  const now = dayjs();
  const hours = now.hour();

  if (isWithin72hOfLastDay(expirationDate, now.clone()))
    return lastDaysAuctionTimeValues();

  if (!isFirstDaySelected(value, now.clone()))
    return defaultAuctionTimeValues();

  const firstHour = now.minute() > 30 ? hours + 1 : hours;
  return firstDayAuctionTimeValues(now, firstHour, val.hour());
};
